import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext(null);

const translations = {
  it: {
    // Navigation
    dashboard: "Dashboard",
    tickets: "Ticket",
    assets: "Asset IT",
    kb: "Knowledge Base",
    technicians: "Tecnici",
    calls: "Chiamata",
    aiChat: "REBECCA",
    admin: "Admin",
    logout: "Esci",
    
    // Status & Priority
    open: "Aperto",
    in_progress: "In Corso",
    resolved: "Risolto",
    closed: "Chiuso",
    low: "Bassa",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente",
    
    // SLA
    sla_compliance: "Conformità SLA",
    sla_breached: "Fuori SLA",
    sla_active: "SLA Attiva",
    sla_warning: "SLA in Scadenza",
    sla_response: "SLA Risposta",
    sla_resolution: "SLA Risoluzione",
    sla_remaining: "rimanenti",
    sla_overdue: "in ritardo di",
    
    // Common Actions / Fields
    actions: "Azioni",
    search: "Cerca...",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    create: "Crea",
    edit: "Modifica",
    title: "Titolo",
    description: "Descrizione",
    priority: "Priorità",
    category: "Categoria",
    status: "Stato",
    name: "Nome",
    email: "Email",
    phone: "Telefono",
    owner: "Proprietario",
    location: "Posizione",
    notes: "Note",
    created_at: "Creato il",
    updated_at: "Aggiornato il",
    
    // Assets
    asset_list: "Inventario Asset",
    create_asset: "Registra Nuovo Asset",
    edit_asset: "Modifica Asset",
    serial_number: "Numero di Serie",
    ip_address: "Indirizzo IP",
    purchase_date: "Data di Acquisto",
    asset_type: "Tipo Asset",
    hardware: "Hardware",
    software: "Software",
    network: "Rete",
    printer: "Stampante",
    mobile: "Dispositivo Mobile",
    other: "Altro",
    active: "Attivo",
    maintenance: "In Manutenzione",
    retired: "Dismesso",
    linked_tickets: "Ticket Collegati",
    link_asset: "Collega Asset IT",
    no_linked_asset: "Nessun asset collegato",
    
    // Knowledge Base
    kb_articles: "Articoli di Supporto",
    search_kb: "Cerca articoli di supporto...",
    create_article: "Crea Articolo",
    edit_article: "Modifica Articolo",
    kb_category: "Categoria KB",
    public: "Pubblico (visibile ai clienti)",
    views: "Visualizzazioni",
    suggested_solutions: "Soluzioni Consigliate",
    search_solutions_first: "Cerca prima una soluzione nella nostra Knowledge Base:",
    no_articles: "Nessun articolo trovato.",
    read_more: "Leggi tutto",
    back_to_kb: "Torna alla Knowledge Base",
    
    // Dashboard & Tickets
    total_tickets: "Ticket Totali",
    my_tickets: "I Miei Ticket",
    ticket_details: "Dettaglio Ticket",
    assigned_to: "Assegnato a",
    resolution_notes: "Note di Risoluzione",
    send_to_user: "Invia notifica al richiedente",
    source: "Sorgente",
    caller: "Richiedente",
    ai_diagnosis: "Diagnosi dell'Intelligenza Artificiale",
    new_ticket: "Apri Nuovo Ticket",
    
    // Telegram
    telegram_settings: "Configurazione Telegram",
    telegram_bot_token: "Token Bot Telegram",
    telegram_chat_id: "ID Chat / Canale Notifiche",
    webhook_active: "Webhook Telegram Attivo",
    open_via_telegram: "Apri ticket via Telegram",
    bot_info_msg: "Fornisci il token del bot Telegram per consentire l'apertura automatica dei ticket.",

    // Layout / navigation chrome
    voice_call_nav: "Assistenza Vocale",
    super_admin_nav: "Super Admin",
    new_ticket: "Nuovo Ticket",
    search_placeholder: "Cerca ovunque…",
    role_super_admin: "Amministratore",
    role_admin: "Admin",
    role_technician: "Tecnico",
    page_dashboard_title: "Dashboard",
    page_dashboard_subtitle: "Panoramica operativa del supporto IT",
    page_tickets_title: "Gestione Ticket",
    page_tickets_subtitle: "Gestisci e monitora tutte le richieste di assistenza",
    page_assets_title: "Asset IT",
    page_assets_subtitle: "Inventario e gestione asset IT",
    page_kb_title: "Knowledge Base",
    page_kb_subtitle: "Articoli e soluzioni di supporto",
    page_technicians_title: "Gestione Tecnici",
    page_technicians_subtitle: "Monitora stato e carico di lavoro del team",
    page_admin_title: "Pannello Super Admin",
    page_admin_subtitle: "Gestione piattaforma, aziende e licenze",
    page_ai_chat_title: "REBECCA AI",
    page_ai_chat_subtitle: "Assistente virtuale per diagnosi e supporto",
    page_voice_call_title: "Assistenza Vocale",
    page_voice_call_subtitle: "Supporto in tempo reale via voce",
    page_upgrade_title: "Piani e Abbonamento",
    page_upgrade_subtitle: "Scegli il piano più adatto alla tua azienda",

    // Auth pages
    auth_tagline: "Piattaforma di Assistenza Intelligente",
    login_title: "Accedi",
    login_subtitle: "Inserisci le tue credenziali per accedere",
    login_button: "Accedi",
    login_in_progress: "Accesso in corso...",
    forgot_password: "Password dimenticata?",
    no_account: "Non hai un account?",
    sign_up: "Registrati",
    need_help: "Hai bisogno di assistenza? Richiedi supporto",
    powered_by: "Powered by IKONET Solutions",

    // Trial signup
    trial_hero_title: "Inizia Gratis",
    trial_hero_subtitle: "7 giorni di prova, funzionalità piena, nessun impegno",
    trial_card_title: "Crea la tua azienda",
    trial_card_subtitle: "Entri subito nella dashboard vera, non in una demo",
    trial_include_1: "Accesso completo per 7 giorni, nessuna carta richiesta",
    trial_include_2: "Fino a 2 tecnici, ticket illimitati",
    trial_include_3: "Chat, email, WhatsApp e Agente IA Rebecca",
    field_company_name: "Nome Azienda",
    field_your_name: "Il tuo nome",
    field_work_email: "Email di lavoro",
    field_password: "Password",
    password_min_length_error: "La password deve essere di almeno 6 caratteri",
    trial_activate_button: "Attiva il trial gratuito",
    trial_activating: "Attivazione in corso...",
    have_account: "Hai già un account?",
  },
  en: {
    // Navigation
    dashboard: "Dashboard",
    tickets: "Tickets",
    assets: "IT Assets",
    kb: "Knowledge Base",
    technicians: "Technicians",
    calls: "Calls",
    aiChat: "REBECCA",
    admin: "Admin",
    logout: "Log Out",
    
    // Status & Priority
    open: "Open",
    in_progress: "In Progress",
    resolved: "Resolved",
    closed: "Closed",
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    
    // SLA
    sla_compliance: "SLA Compliance",
    sla_breached: "SLA Breached",
    sla_active: "SLA Active",
    sla_warning: "SLA Warning",
    sla_response: "Response SLA",
    sla_resolution: "Resolution SLA",
    sla_remaining: "remaining",
    sla_overdue: "overdue by",
    
    // Common Actions / Fields
    actions: "Actions",
    search: "Search...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    create: "Create",
    edit: "Edit",
    title: "Title",
    description: "Description",
    priority: "Priority",
    category: "Category",
    status: "Status",
    name: "Name",
    email: "Email",
    phone: "Phone",
    owner: "Owner",
    location: "Location",
    notes: "Notes",
    created_at: "Created at",
    updated_at: "Updated at",
    
    // Assets
    asset_list: "Asset Inventory",
    create_asset: "Register New Asset",
    edit_asset: "Edit Asset",
    serial_number: "Serial Number",
    ip_address: "IP Address",
    purchase_date: "Purchase Date",
    asset_type: "Asset Type",
    hardware: "Hardware",
    software: "Software",
    network: "Network",
    printer: "Printer",
    mobile: "Mobile Device",
    other: "Other",
    active: "Active",
    maintenance: "In Maintenance",
    retired: "Retired",
    linked_tickets: "Linked Tickets",
    link_asset: "Link IT Asset",
    no_linked_asset: "No linked asset",
    
    // Knowledge Base
    kb_articles: "Knowledge Base Articles",
    search_kb: "Search support articles...",
    create_article: "Create Article",
    edit_article: "Edit Article",
    kb_category: "KB Category",
    public: "Public (visible to clients)",
    views: "Views",
    suggested_solutions: "Suggested Solutions",
    search_solutions_first: "Search for a solution in our Knowledge Base first:",
    no_articles: "No articles found.",
    read_more: "Read more",
    back_to_kb: "Back to Knowledge Base",
    
    // Dashboard & Tickets
    total_tickets: "Total Tickets",
    my_tickets: "My Tickets",
    ticket_details: "Ticket Details",
    assigned_to: "Assigned To",
    resolution_notes: "Resolution Notes",
    send_to_user: "Send notification to requester",
    source: "Source",
    caller: "Requester",
    ai_diagnosis: "Artificial Intelligence Diagnosis",
    new_ticket: "Open New Ticket",
    
    // Telegram
    telegram_settings: "Telegram Settings",
    telegram_bot_token: "Telegram Bot Token",
    telegram_chat_id: "Notification Chat / Channel ID",
    webhook_active: "Telegram Webhook Active",
    open_via_telegram: "Open ticket via Telegram",
    bot_info_msg: "Provide a Telegram bot token to allow automatic ticket creation.",

    // Layout / navigation chrome
    voice_call_nav: "Voice Support",
    super_admin_nav: "Super Admin",
    new_ticket: "New Ticket",
    search_placeholder: "Search anywhere…",
    role_super_admin: "Administrator",
    role_admin: "Admin",
    role_technician: "Technician",
    page_dashboard_title: "Dashboard",
    page_dashboard_subtitle: "Operational overview of IT support",
    page_tickets_title: "Ticket Management",
    page_tickets_subtitle: "Manage and monitor all support requests",
    page_assets_title: "IT Assets",
    page_assets_subtitle: "IT asset inventory and management",
    page_kb_title: "Knowledge Base",
    page_kb_subtitle: "Support articles and solutions",
    page_technicians_title: "Technician Management",
    page_technicians_subtitle: "Monitor team status and workload",
    page_admin_title: "Super Admin Panel",
    page_admin_subtitle: "Platform, company, and license management",
    page_ai_chat_title: "REBECCA AI",
    page_ai_chat_subtitle: "Virtual assistant for diagnosis and support",
    page_voice_call_title: "Voice Support",
    page_voice_call_subtitle: "Real-time support over voice",
    page_upgrade_title: "Plans & Subscription",
    page_upgrade_subtitle: "Choose the plan that fits your company",

    // Auth pages
    auth_tagline: "Smart Support Platform",
    login_title: "Log In",
    login_subtitle: "Enter your credentials to sign in",
    login_button: "Log In",
    login_in_progress: "Signing in...",
    forgot_password: "Forgot password?",
    no_account: "Don't have an account?",
    sign_up: "Sign Up",
    need_help: "Need help? Request support",
    powered_by: "Powered by IKONET Solutions",

    // Trial signup
    trial_hero_title: "Start Free",
    trial_hero_subtitle: "7-day trial, full functionality, no commitment",
    trial_card_title: "Create Your Company",
    trial_card_subtitle: "You go straight into the real dashboard, not a demo",
    trial_include_1: "Full access for 7 days, no card required",
    trial_include_2: "Up to 2 technicians, unlimited tickets",
    trial_include_3: "Chat, email, WhatsApp and the Rebecca AI Agent",
    field_company_name: "Company Name",
    field_your_name: "Your Name",
    field_work_email: "Work Email",
    field_password: "Password",
    password_min_length_error: "Password must be at least 6 characters",
    trial_activate_button: "Activate Free Trial",
    trial_activating: "Activating...",
    have_account: "Already have an account?",
  },
  es: {
    // Navigation
    dashboard: "Panel",
    tickets: "Tickets",
    assets: "Activos IT",
    kb: "Base de Conocimientos",
    technicians: "Técnicos",
    calls: "Llamadas",
    aiChat: "REBECCA",
    admin: "Admin",
    logout: "Cerrar sesión",
    
    // Status & Priority
    open: "Abierto",
    in_progress: "En Curso",
    resolved: "Resuelto",
    closed: "Cerrado",
    low: "Baja",
    medium: "Media",
    high: "Alta",
    urgent: "Urgente",
    
    // SLA
    sla_compliance: "Cumplimiento SLA",
    sla_breached: "SLA Vencida",
    sla_active: "SLA Activa",
    sla_warning: "SLA en Advertencia",
    sla_response: "SLA de Respuesta",
    sla_resolution: "SLA de Resolución",
    sla_remaining: "restantes",
    sla_overdue: "vencido por",
    
    // Common Actions / Fields
    actions: "Acciones",
    search: "Buscar...",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    create: "Crear",
    edit: "Editar",
    title: "Título",
    description: "Descripción",
    priority: "Prioridad",
    category: "Categoría",
    status: "Estado",
    name: "Nombre",
    email: "Correo",
    phone: "Teléfono",
    owner: "Propietario",
    location: "Ubicación",
    notes: "Notas",
    created_at: "Creado el",
    updated_at: "Actualizado el",
    
    // Assets
    asset_list: "Inventario de Activos",
    create_asset: "Registrar Nuevo Activo",
    edit_asset: "Editar Activo",
    serial_number: "Número de Serie",
    ip_address: "Dirección IP",
    purchase_date: "Fecha de Compra",
    asset_type: "Tipo de Activo",
    hardware: "Hardware",
    software: "Software",
    network: "Red",
    printer: "Impresora",
    mobile: "Dispositivo Móvil",
    other: "Otro",
    active: "Activo",
    maintenance: "En Mantenimiento",
    retired: "Retirado",
    linked_tickets: "Tickets Vinculados",
    link_asset: "Vincular Activo IT",
    no_linked_asset: "Sin activo vinculado",
    
    // Knowledge Base
    kb_articles: "Artículos de Soporte",
    search_kb: "Buscar artículos de soporte...",
    create_article: "Crear Artículo",
    edit_article: "Editar Artículo",
    kb_category: "Categoría KB",
    public: "Público (visible a clientes)",
    views: "Vistas",
    suggested_solutions: "Soluciones Sugeridas",
    search_solutions_first: "Busque una solución en nuestra Base de Conocimientos primero:",
    no_articles: "No se encontraron artículos.",
    read_more: "Leer más",
    back_to_kb: "Volver a la Base de Conocimientos",
    
    // Dashboard & Tickets
    total_tickets: "Tickets Totales",
    my_tickets: "Mis Tickets",
    ticket_details: "Detalle del Ticket",
    assigned_to: "Asignado a",
    resolution_notes: "Notas de Resolución",
    send_to_user: "Enviar notificación al solicitante",
    source: "Fuente",
    caller: "Solicitante",
    ai_diagnosis: "Diagnóstico de Inteligencia Artificial",
    new_ticket: "Abrir Nuevo Ticket",
    
    // Telegram
    telegram_settings: "Configuración de Telegram",
    telegram_bot_token: "Token de Bot Telegram",
    telegram_chat_id: "ID de Chat / Canal de Notificaciones",
    webhook_active: "Webhook Telegram Activo",
    open_via_telegram: "Abrir ticket vía Telegram",
    bot_info_msg: "Proporcione el token del bot de Telegram para permitir la creación automática de tickets.",

    // Layout / navigation chrome
    voice_call_nav: "Soporte por Voz",
    super_admin_nav: "Super Admin",
    new_ticket: "Nuevo Ticket",
    search_placeholder: "Buscar en todas partes…",
    role_super_admin: "Administrador",
    role_admin: "Admin",
    role_technician: "Técnico",
    page_dashboard_title: "Panel",
    page_dashboard_subtitle: "Panorama operativo del soporte IT",
    page_tickets_title: "Gestión de Tickets",
    page_tickets_subtitle: "Gestiona y supervisa todas las solicitudes de soporte",
    page_assets_title: "Activos IT",
    page_assets_subtitle: "Inventario y gestión de activos IT",
    page_kb_title: "Base de Conocimientos",
    page_kb_subtitle: "Artículos y soluciones de soporte",
    page_technicians_title: "Gestión de Técnicos",
    page_technicians_subtitle: "Supervisa el estado y la carga de trabajo del equipo",
    page_admin_title: "Panel de Super Admin",
    page_admin_subtitle: "Gestión de plataforma, empresas y licencias",
    page_ai_chat_title: "REBECCA AI",
    page_ai_chat_subtitle: "Asistente virtual para diagnóstico y soporte",
    page_voice_call_title: "Soporte por Voz",
    page_voice_call_subtitle: "Soporte en tiempo real por voz",
    page_upgrade_title: "Planes y Suscripción",
    page_upgrade_subtitle: "Elige el plan más adecuado para tu empresa",

    // Auth pages
    auth_tagline: "Plataforma Inteligente de Soporte",
    login_title: "Iniciar Sesión",
    login_subtitle: "Introduce tus credenciales para acceder",
    login_button: "Iniciar Sesión",
    login_in_progress: "Iniciando sesión...",
    forgot_password: "¿Olvidaste tu contraseña?",
    no_account: "¿No tienes una cuenta?",
    sign_up: "Regístrate",
    need_help: "¿Necesitas ayuda? Solicita soporte",
    powered_by: "Desarrollado por IKONET Solutions",

    // Trial signup
    trial_hero_title: "Empieza Gratis",
    trial_hero_subtitle: "7 días de prueba, funcionalidad completa, sin compromiso",
    trial_card_title: "Crea tu empresa",
    trial_card_subtitle: "Accedes directamente al panel real, no a una demo",
    trial_include_1: "Acceso completo durante 7 días, sin tarjeta requerida",
    trial_include_2: "Hasta 2 técnicos, tickets ilimitados",
    trial_include_3: "Chat, email, WhatsApp y el Agente IA Rebecca",
    field_company_name: "Nombre de la Empresa",
    field_your_name: "Tu nombre",
    field_work_email: "Email de trabajo",
    field_password: "Contraseña",
    password_min_length_error: "La contraseña debe tener al menos 6 caracteres",
    trial_activate_button: "Activar prueba gratuita",
    trial_activating: "Activando...",
    have_account: "¿Ya tienes una cuenta?",
  },
  fr: {
    // Navigation
    dashboard: "Tableau de bord",
    tickets: "Tickets",
    assets: "Actifs IT",
    kb: "Base de Connaissances",
    technicians: "Techniciens",
    calls: "Appels",
    aiChat: "REBECCA",
    admin: "Admin",
    logout: "Déconnexion",
    
    // Status & Priority
    open: "Ouvert",
    in_progress: "En Cours",
    resolved: "Résolu",
    closed: "Fermé",
    low: "Basse",
    medium: "Moyenne",
    high: "Haute",
    urgent: "Urgente",
    
    // SLA
    sla_compliance: "Conformité SLA",
    sla_breached: "SLA Dépassée",
    sla_active: "SLA Active",
    sla_warning: "SLA en Avertissement",
    sla_response: "SLA de Réponse",
    sla_resolution: "SLA de Résolution",
    sla_remaining: "restantes",
    sla_overdue: "dépassé de",
    
    // Common Actions / Fields
    actions: "Actions",
    search: "Rechercher...",
    save: "Sauvegarder",
    cancel: "Annuler",
    delete: "Supprimer",
    create: "Créer",
    edit: "Modifier",
    title: "Titre",
    description: "Description",
    priority: "Priorité",
    category: "Catégorie",
    status: "Statut",
    name: "Nom",
    email: "Email",
    phone: "Téléphone",
    owner: "Propriétaire",
    location: "Emplacement",
    notes: "Notes",
    created_at: "Créé le",
    updated_at: "Mis à jour le",
    
    // Assets
    asset_list: "Inventaire des Actifs",
    create_asset: "Enregistrer Nouvel Actif",
    edit_asset: "Modifier l'Actif",
    serial_number: "Numéro de Série",
    ip_address: "Adresse IP",
    purchase_date: "Date d'Achat",
    asset_type: "Type d'Actif",
    hardware: "Matériel",
    software: "Logiciel",
    network: "Réseau",
    printer: "Imprimante",
    mobile: "Appareil Mobile",
    other: "Autre",
    active: "Actif",
    maintenance: "En Maintenance",
    retired: "Retiré",
    linked_tickets: "Tickets Associés",
    link_asset: "Lier un Actif IT",
    no_linked_asset: "Aucun actif lié",
    
    // Knowledge Base
    kb_articles: "Articles de Support",
    search_kb: "Rechercher des articles...",
    create_article: "Créer un Article",
    edit_article: "Modifier l'Article",
    kb_category: "Catégorie KB",
    public: "Public (visible par les clients)",
    views: "Vues",
    suggested_solutions: "Solutions Suggérées",
    search_solutions_first: "Recherchez d'abord une solution dans notre Base de Connaissances:",
    no_articles: "Aucun article trouvé.",
    read_more: "Lire la suite",
    back_to_kb: "Retour à la Base de Connaissances",
    
    // Dashboard & Tickets
    total_tickets: "Tickets Totaux",
    my_tickets: "Mes Tickets",
    ticket_details: "Détail du Ticket",
    assigned_to: "Assigné à",
    resolution_notes: "Notes de Résolution",
    send_to_user: "Envoyer une notification au demandeur",
    source: "Source",
    caller: "Demandeur",
    ai_diagnosis: "Diagnostic de l'Intelligence Artificielle",
    new_ticket: "Ouvrir un Nouveau Ticket",
    
    // Telegram
    telegram_settings: "Paramètres Telegram",
    telegram_bot_token: "Token du Bot Telegram",
    telegram_chat_id: "ID Chat / Canal de Notifications",
    webhook_active: "Webhook Telegram Actif",
    open_via_telegram: "Ouvrir ticket via Telegram",
    bot_info_msg: "Fournissez le token du bot Telegram pour permettre la création automatique de tickets.",

    // Layout / navigation chrome
    voice_call_nav: "Support Vocal",
    super_admin_nav: "Super Admin",
    new_ticket: "Nouveau Ticket",
    search_placeholder: "Rechercher partout…",
    role_super_admin: "Administrateur",
    role_admin: "Admin",
    role_technician: "Technicien",
    page_dashboard_title: "Tableau de bord",
    page_dashboard_subtitle: "Aperçu opérationnel du support IT",
    page_tickets_title: "Gestion des Tickets",
    page_tickets_subtitle: "Gérez et suivez toutes les demandes d'assistance",
    page_assets_title: "Actifs IT",
    page_assets_subtitle: "Inventaire et gestion des actifs IT",
    page_kb_title: "Base de Connaissances",
    page_kb_subtitle: "Articles et solutions d'assistance",
    page_technicians_title: "Gestion des Techniciens",
    page_technicians_subtitle: "Suivez le statut et la charge de travail de l'équipe",
    page_admin_title: "Panneau Super Admin",
    page_admin_subtitle: "Gestion de la plateforme, des entreprises et des licences",
    page_ai_chat_title: "REBECCA AI",
    page_ai_chat_subtitle: "Assistant virtuel pour diagnostic et support",
    page_voice_call_title: "Support Vocal",
    page_voice_call_subtitle: "Assistance en temps réel par la voix",
    page_upgrade_title: "Plans et Abonnement",
    page_upgrade_subtitle: "Choisissez le plan adapté à votre entreprise",

    // Auth pages
    auth_tagline: "Plateforme d'Assistance Intelligente",
    login_title: "Connexion",
    login_subtitle: "Entrez vos identifiants pour vous connecter",
    login_button: "Connexion",
    login_in_progress: "Connexion en cours...",
    forgot_password: "Mot de passe oublié ?",
    no_account: "Vous n'avez pas de compte ?",
    sign_up: "Inscrivez-vous",
    need_help: "Besoin d'aide ? Demandez de l'assistance",
    powered_by: "Propulsé par IKONET Solutions",

    // Trial signup
    trial_hero_title: "Commencez Gratuitement",
    trial_hero_subtitle: "Essai de 7 jours, fonctionnalités complètes, sans engagement",
    trial_card_title: "Créez votre entreprise",
    trial_card_subtitle: "Vous accédez directement au vrai tableau de bord, pas à une démo",
    trial_include_1: "Accès complet pendant 7 jours, aucune carte requise",
    trial_include_2: "Jusqu'à 2 techniciens, tickets illimités",
    trial_include_3: "Chat, email, WhatsApp et l'Agent IA Rebecca",
    field_company_name: "Nom de l'entreprise",
    field_your_name: "Votre nom",
    field_work_email: "Email professionnel",
    field_password: "Mot de passe",
    password_min_length_error: "Le mot de passe doit contenir au moins 6 caractères",
    trial_activate_button: "Activer l'essai gratuit",
    trial_activating: "Activation en cours...",
    have_account: "Vous avez déjà un compte ?",
  },
  de: {
    // Navigation
    dashboard: "Dashboard",
    tickets: "Tickets",
    assets: "IT-Anlagen",
    kb: "Wissensdatenbank",
    technicians: "Techniker",
    calls: "Anrufe",
    aiChat: "REBECCA",
    admin: "Admin",
    logout: "Abmelden",
    
    // Status & Priority
    open: "Offen",
    in_progress: "In Bearbeitung",
    resolved: "Gelöst",
    closed: "Geschlossen",
    low: "Niedrig",
    medium: "Mittel",
    high: "Hoch",
    urgent: "Dringend",
    
    // SLA
    sla_compliance: "SLA-Konformität",
    sla_breached: "SLA verletzt",
    sla_active: "SLA Aktiv",
    sla_warning: "SLA Warnung",
    sla_response: "Antwort-SLA",
    sla_resolution: "Lösungs-SLA",
    sla_remaining: "verbleibend",
    sla_overdue: "überfällig um",
    
    // Common Actions / Fields
    actions: "Aktionen",
    search: "Suchen...",
    save: "Speichern",
    cancel: "Abbrechen",
    delete: "Löschen",
    create: "Erstellen",
    edit: "Bearbeiten",
    title: "Titel",
    description: "Beschreibung",
    priority: "Priorität",
    category: "Kategorie",
    status: "Status",
    name: "Name",
    email: "E-Mail",
    phone: "Telefon",
    owner: "Besitzer",
    location: "Standort",
    notes: "Notizen",
    created_at: "Erstellt am",
    updated_at: "Aktualisiert am",
    
    // Assets
    asset_list: "Anlagenbestand",
    create_asset: "Neue Anlage registrieren",
    edit_asset: "Anlage bearbeiten",
    serial_number: "Seriennummer",
    ip_address: "IP-Adresse",
    purchase_date: "Kaufdatum",
    asset_type: "Anlagentyp",
    hardware: "Hardware",
    software: "Software",
    network: "Netzwerk",
    printer: "Drucker",
    mobile: "Mobilgerät",
    other: "Andere",
    active: "Aktiv",
    maintenance: "In Wartung",
    retired: "Ausgemustert",
    linked_tickets: "Verknüpfte Tickets",
    link_asset: "IT-Anlage verknüpfen",
    no_linked_asset: "Keine Anlage verknüpft",
    
    // Knowledge Base
    kb_articles: "Hilfeartikel",
    search_kb: "Wissensdatenbank durchsuchen...",
    create_article: "Artikel erstellen",
    edit_article: "Artikel bearbeiten",
    kb_category: "KB-Kategorie",
    public: "Öffentlich (für Kunden sichtbar)",
    views: "Aufrufe",
    suggested_solutions: "Empfohlene Lösungen",
    search_solutions_first: "Suchen Sie zuerst in unserer Wissensdatenbank nach einer Lösung:",
    no_articles: "Keine Artikel gefunden.",
    read_more: "Weiterlesen",
    back_to_kb: "Zurück zur Wissensdatenbank",
    
    // Dashboard & Tickets
    total_tickets: "Tickets Gesamt",
    my_tickets: "Meine Tickets",
    ticket_details: "Ticket-Details",
    assigned_to: "Zugewiesen an",
    resolution_notes: "Lösungshinweise",
    send_to_user: "Benachrichtigung an Antragsteller senden",
    source: "Quelle",
    caller: "Antragsteller",
    ai_diagnosis: "Künstliche Intelligenz Diagnose",
    new_ticket: "Neues Ticket öffnen",
    
    // Telegram
    telegram_settings: "Telegram-Einstellungen",
    telegram_bot_token: "Telegram-Bot-Token",
    telegram_chat_id: "Benachrichtigungs-Chat/Kanal-ID",
    webhook_active: "Telegram Webhook Aktiv",
    open_via_telegram: "Ticket per Telegram öffnen",
    bot_info_msg: "Geben Sie ein Telegram-Bot-Token an, um die automatische Ticket-Erstellung zu ermöglichen.",

    // Layout / navigation chrome
    voice_call_nav: "Sprachsupport",
    super_admin_nav: "Super Admin",
    new_ticket: "Neues Ticket",
    search_placeholder: "Überall suchen…",
    role_super_admin: "Administrator",
    role_admin: "Admin",
    role_technician: "Techniker",
    page_dashboard_title: "Dashboard",
    page_dashboard_subtitle: "Betriebsübersicht des IT-Supports",
    page_tickets_title: "Ticket-Verwaltung",
    page_tickets_subtitle: "Verwalten und überwachen Sie alle Support-Anfragen",
    page_assets_title: "IT-Anlagen",
    page_assets_subtitle: "Bestand und Verwaltung der IT-Anlagen",
    page_kb_title: "Wissensdatenbank",
    page_kb_subtitle: "Support-Artikel und Lösungen",
    page_technicians_title: "Techniker-Verwaltung",
    page_technicians_subtitle: "Status und Auslastung des Teams überwachen",
    page_admin_title: "Super-Admin-Panel",
    page_admin_subtitle: "Verwaltung von Plattform, Unternehmen und Lizenzen",
    page_ai_chat_title: "REBECCA AI",
    page_ai_chat_subtitle: "Virtueller Assistent für Diagnose und Support",
    page_voice_call_title: "Sprachsupport",
    page_voice_call_subtitle: "Echtzeit-Support per Sprache",
    page_upgrade_title: "Pläne & Abonnement",
    page_upgrade_subtitle: "Wählen Sie den passenden Plan für Ihr Unternehmen",

    // Auth pages
    auth_tagline: "Intelligente Support-Plattform",
    login_title: "Anmelden",
    login_subtitle: "Geben Sie Ihre Zugangsdaten ein, um sich anzumelden",
    login_button: "Anmelden",
    login_in_progress: "Anmeldung läuft...",
    forgot_password: "Passwort vergessen?",
    no_account: "Noch kein Konto?",
    sign_up: "Registrieren",
    need_help: "Brauchen Sie Hilfe? Support anfordern",
    powered_by: "Bereitgestellt von IKONET Solutions",

    // Trial signup
    trial_hero_title: "Kostenlos Starten",
    trial_hero_subtitle: "7 Tage Testphase, voller Funktionsumfang, keine Verpflichtung",
    trial_card_title: "Erstellen Sie Ihr Unternehmen",
    trial_card_subtitle: "Sie gelangen direkt ins echte Dashboard, nicht in eine Demo",
    trial_include_1: "Voller Zugriff für 7 Tage, keine Kreditkarte erforderlich",
    trial_include_2: "Bis zu 2 Techniker, unbegrenzte Tickets",
    trial_include_3: "Chat, E-Mail, WhatsApp und der Rebecca KI-Agent",
    field_company_name: "Firmenname",
    field_your_name: "Ihr Name",
    field_work_email: "Geschäftliche E-Mail",
    field_password: "Passwort",
    password_min_length_error: "Das Passwort muss mindestens 6 Zeichen lang sein",
    trial_activate_button: "Kostenlose Testphase aktivieren",
    trial_activating: "Aktivierung läuft...",
    have_account: "Sie haben bereits ein Konto?",
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try {
      const saved = localStorage.getItem('language');
      if (saved && translations[saved]) {
        return saved;
      }
    } catch (e) {}
    
    // Default to browser language if supported, else 'it' (fallback to 'en' if not 'it')
    try {
      const navLang = navigator.language?.split('-')[0];
      if (navLang && translations[navLang]) {
        return navLang;
      }
    } catch (e) {}
    
    return 'it';
  });

  const setLanguage = (lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
      try {
        localStorage.setItem('language', lang);
      } catch (e) {}
    }
  };

  const t = (key) => {
    const langDict = translations[language] || translations['en'];
    return langDict[key] || translations['en'][key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, languages: Object.keys(translations) }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useTranslation() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
